import { activationApi } from './activation'
import { publishApi } from './publish'
import { runApi } from './run'
import { snapshotApi } from './snapshot'
import { taskApi } from './task'

export const scheduleApi = {
  ...taskApi,
  ...runApi,
  ...snapshotApi,
  ...publishApi,
  ...activationApi
}

export {
  buildClassOptionKey,
  compareClassNames,
  createOccurrenceKey,
  extractClassNumber,
  isSubgroupVisibleForTarget,
  sortClassOptions,
  sortGradeOptions,
  buildGradeOrderMapFromGrades,
  buildGradeOrderMapFromClasses
} from './shared'

export {
  buildDraftOccurrencesFromTask,
  buildScheduleClassOptions,
  buildScheduleTeacherOptions,
  buildSubjectWeeklyFrequencyMap,
  sortTeacherOptionsBySubjectAndName,
  taskStageFromTaskStatus
} from './task'

export {
  buildDraftOccurrencesFromSnapshot,
  sortStagedCourses
} from './snapshot'
